import {
  GetAgentProfileResult,
  UpsertAgentProfileInput,
  UpsertAgentProfileResult,
} from "@cruisen/contract"
import { callFirebaseFunction } from "../callFirebaseFunction"

export const getAgentProfile = async (userId: string) => {
  if (!userId) return null

  const response = await callFirebaseFunction({
    name: "agentProfileAction",
    payload: {
      action: "getAgentProfile",
      userId,
    },
  })
  if (response.error) {
    console.log(response)
    return null
  }
  return response.data?.result as GetAgentProfileResult
}

export const upsertAgentProfile = async (payload: UpsertAgentProfileInput) => {
  const response = await callFirebaseFunction({
    name: "agentProfileAction",
    payload: {
      action: "upsertAgentProfile",
      ...payload,
    },
  })
  if (response.error) {
    console.log(response)
    return undefined
  }

  const result = response.data?.result as UpsertAgentProfileResult

  return result?.updatedAgentProfile
}

export const deleteAgentProfile = async () => {
  const response = await callFirebaseFunction({
    name: "agentProfileAction",
    payload: {
      action: "deleteAgentProfile",
    },
  })
  if (response.error) {
    console.log(response)
    return undefined
  }

  const result = response.data?.result as UpsertAgentProfileResult

  return result?.updatedAgentProfile
}

export const getAgentDetailsByCode = async (agentCode: string) => {
  const response = await callFirebaseFunction({
    name: "agentProfileAction",
    payload: {
      action: "getAgentProfile",
      agentCode,
    },
  })
  if (response.error) {
    return undefined
  }
  return response.data?.result as GetAgentProfileResult
}
